<template>
	<!--左侧菜单-开始-->
	<div class="left_pannel_box">
		<ul>
			<li :class="fileName === 'index' ?'selected':''">
				<div class="item_box">
					<a href="index">
					<div class="icon home"></div>
					<div class="menu_txt">
						<h3>我的账户</h3>
						<p>一站式个人账号与资产订单管理</p>
					</div>
					</a>
				</div>
			</li>
			<li :class="fileName === 'orders' ?'selected':''">
				<div class="item_box">
					<a href="orders">
					<div class="icon order"></div>
					<div class="menu_txt">
						<h3>订单中心</h3>
						<p>跟踪订单，随时获知最新动态</p>
					</div>
					</a>
				</div>
			</li>
			<li :class="fileName === 'collections' ?'selected':''">
				<div class="item_box">
					<a href="collections">
					<div class="icon favorite"></div>
					<div class="menu_txt">
						<h3>收藏夹</h3>
						<p>及时了解关注内容的价格变动</p>
					</div>
					</a>
				</div>
			</li>
			<li :class="fileName === 'profile' ?'selected':''">
				<div class="item_box">
					<a href="profile">
					<div class="icon contact"></div>
					<div class="menu_txt">
						<h3>联系信息</h3>
						<p>设置通讯信息，随时保持联络</p>
					</div>
					</a>
				</div>
			</li>
			<li :class="fileName === 'reset_password' ?'selected':''">
				<div class="item_box">
					<a href="reset_password">
					<div class="icon password"></div>
					<div class="menu_txt">
						<h3>重置密码</h3>
						<p>请妥善保管好您的密码</p>
					</div>
					</a>
				</div>
			</li>
		</ul>
		<div class="logout">
			<a href="javascript:void(0)" @click="userLogout()">退出登录</a>
		</div>
	</div>
	<!--左侧菜单-结束-->
</template>

<script>
	import {
		userLogout,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	export default {
		name: 'CNUserLeftPannel',
		props: ['fileName','Token'],
		mixins: [mixin],
		data() {
			return {				
				language: 'cn', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
			}
		},
		methods: {
			// 退出登录
			async userLogout()
			{
				let params={
					Token: this.Token,
					Terminal: this.terminal,
				}
				
				const { data: res } = await userLogout(params)
				if (res.errcode === 0) {
					this.$storeage.remove('token')
					this.$storeage.remove('expire')
					this.token = null
					this.loginStatus = false
					
					this.$router.push({
						path: '/cn/user/login'
					})
				} else {
					this.$message.error(res.errmsg);
				}
			}
		},
		created() {
		},
		beforeDestroy() {

		}
	}
</script>

<style lang="less" scoped>

</style>